import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Navigation from '../components/layout/Navigation';
import anniversaryData from '../utils/data';

const Playlist: React.FC = () => {
  const { playlist } = anniversaryData;
  const spotifyEmbedUrl = `https://open.spotify.com/embed/playlist/${playlist.id}?utm_source=generator&theme=0`;

  return (
    <PlaylistContainer>
      <Navigation />
      
      <PlaylistContent
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <PlaylistHeader>
          <PlaylistTitle>{playlist.title}</PlaylistTitle>
          <PlaylistDescription>{playlist.description}</PlaylistDescription>
        </PlaylistHeader>

        <SpotifyEmbed>
          <iframe
            src={spotifyEmbedUrl}
            width="100%"
            height="600"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            title="Spotify Playlist"
          />
        </SpotifyEmbed>

        <PlaylistFooter>
          <SpotifyLink 
            href={`https://open.spotify.com/playlist/${playlist.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in Spotify
          </SpotifyLink>
        </PlaylistFooter>
      </PlaylistContent>
    </PlaylistContainer>
  );
};

const PlaylistContainer = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
  padding: 6rem 2rem 2rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 5rem 1rem 1rem;
  }
`;

const PlaylistContent = styled(motion.div)`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
`;

const PlaylistHeader = styled.div`
  margin-bottom: 3rem;
`;

const PlaylistTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  background: ${({ theme }) => theme.gradients.primary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }
`;

const PlaylistDescription = styled.p`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 2rem;
`;

const SpotifyEmbed = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.large};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.large};
  margin-bottom: 3rem;
  
  iframe {
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    iframe {
      height: 500px;
    }
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    iframe {
      height: 400px;
    }
  }
`;

const PlaylistFooter = styled.div`
  margin-top: 2rem;
`;

const SpotifyLink = styled.a`
  display: inline-block;
  background-color: #1DB954;
  color: white;
  padding: 1rem 2rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #1ed760;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(29, 185, 84, 0.3);
  }
`;

export default Playlist; 